<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-select-item-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalSelectItem"
    ></button>
    <div
      class="modal fade"
      id="modalSelectItem"
      tabindex="-1"
      aria-labelledby="modalSelectItemLabel"
      aria-hidden="true"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="d-flex align-items-center">
              <h5 class="modal-title">Add Items to Transfer</h5>
              <div
                class="d-flex align-items-center"
                v-if="form.source_name || form.branch"
              >
                <div class="mx-3">-</div>
                <h5 class="modal-title mb-0" style="color: #007bff">
                  <span v-if="form.source_name"
                    >From:
                    {{
                      physicalBranches.find(
                        (branch) => branch.value === form.source_name
                      )?.label
                    }}</span
                  ><span
                    :class="form.source_name ? 'ms-3' : ''"
                    v-if="form.branch"
                    >To:
                    {{
                      physicalBranches.find(
                        (branch) => branch.value === form.branch
                      )?.label
                    }}</span
                  >
                </h5>
              </div>
            </div>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div v-if="isLoadDone" v-show="isLoadDoneDataTable">
              <div>
                <div class="px-0 pb-2">
                  <div class="d-flex justify-content-center align-items-center my-3">
                    <div class="col-12 mb-1 d-flex justify-content-center align-items-center">
                      <div class="search-container ">
                        <input
                          class="nosubmit"
                          type="search"
                          id="keyword"
                          v-model="keyword"
                          extraClass
                          name="keyword"
                          placeholder="Item Name, Item No, Barcode,..."
                          @keyup.enter="searchItems"
                        />
                        <button
                          class="btn btn-primary search-btn"
                          type="button"
                          @click="searchItems"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="p-0 custom-table">
                    <table
                      class="table align-items-center mb-0 dataTable"
                      ref="dataTable"
                    >
                      <thead>
                        <tr>
                          <th class="text-left font-weight-bolder"></th>
                          <template
                            v-for="(item, index) in headersData"
                            :key="index"
                          >
                            <th
                              class="text-left font-weight-bolder position-relative"
                            >
                              <div v-html="item.label"></div>
                            </th>
                          </template>
                        </tr>
                        <!-- <tr>
                          <th class="text-center font-weight-bolder"></th>
                          <template
                            v-for="(item, index) in headersData"
                            :key="index"
                          >
                            <th class="text-center font-weight-bolder">
                              <input
                                v-model="columnSearch[index + 1]"
                                @input="searchColumn(index + 1)"
                              />
                            </th>
                          </template>
                        </tr> -->
                      </thead>
                      <tbody>
                        <tr v-for="(value, index) in items" :key="index">
                          <td class="text-center text-xss w-5">
                            <MaterialCheckbox
                              @click="checkItem(value.id, value)"
                              :checked="idsSelect.includes(value.id)"
                              :value="value.id"
                              class="align-items-center checkbox-custom"
                            />
                          </td>
                          <td class="text-left text-xss w-15">
                            {{ value?.item_no }}
                          </td>
                          <td class="text-left text-xss w-15">
                            {{ value?.barcode }}
                          </td>
                          <td class="text-left text-xss w-35">
                            {{ value?.item_name }}
                          </td>
                          <td class="text-left text-xss w-10" v-if="stockAction == STOCK_TRANSFER">
                            {{ value?.source_qty }}
                          </td>
                          <td class="text-left text-xss w-10">
                            {{ value?.dest_qty }}
                          </td>
                          <td class="text-left text-xss w-10">
                            <MaterialInput
                              v-model="value.qty"
                              type="number"
                              id="qty"
                              name="qty"
                              placeholder="Qty"
                              min="0"
                              step="1"
                              @input="changeQty($event, index, value)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer flex-column justify-content-end">
            <div class="w-100">
              <pagination
                v-if="pagination.last_page > 1"
                :pagination="pagination"
                :current_page="pagination.current_page"
                :last_page="pagination.last_page"
                class="mx-2 mb-3"
                style="padding: 0 !important"
              />
            </div>
            <div class="d-flex mt-3 w-100 justify-content-end">
              <material-button
                class="mx-2 btn btn-sm btn-background btn-close-select-item-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background btn-save"
                @click="addItem()"
              >
                Add
              </material-button>
            </div>
          </div>
          <material-loading :active="loaderActive" />
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import "@vueform/multiselect/themes/default.css";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import InventoryService from "../../../services/inventory.service";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import $ from "jquery";
import MaterialInput from "@/components/MaterialInput.vue";
import Pagination from "@/components/Pagination.vue";
import { STOCK_TRANSFER, STOCK_IN, STOCK_OUT } from "../mock_data";

export default {
  name: "inventory-modal-select-item",
  components: {
    MaterialButton,
    MaterialSnackbar,
    MaterialLoading,
    MaterialCheckbox,
    MaterialInput,
    Pagination,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    idsSelected: {
      type: Array,
      required: true,
    },
    itemsSelected: {
      type: Array,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    physicalBranches: {
      type: Array,
      required: true,
    },
    stockAction: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      message: "",
      snackbar: null,
      loaderActive: false,
      pagination: {},
      page: 1,
      dataTable: null,
      columnSearch: [],
      items: [],
      idsSelect: [...this.idsSelected],
      itemsSelect: JSON.parse(JSON.stringify(this.itemsSelected)),
      STOCK_TRANSFER,
      STOCK_IN,
      STOCK_OUT,
      keyword: "",
    };
  },
  computed: {
    headersData() {
      let headers = [
        {
          label: "Item no",
          // field: "item_no",
          hasSortBy: false,
        },
        {
          label: "Barcode",
          // field: "barcode",
          hasSortBy: false,
        },
        {
          label: "Item name",
          // field: "item_name",
          hasSortBy: false,
        },
        {
          label: "Dest <br> Qty",
          // field: "qty",
          hasSortBy: false,
        },
        {
          label: "Transfer <br> Qty",
          // field: "qty",
          hasSortBy: false,
        },
      ];

      if (this.stockAction == STOCK_TRANSFER) {
        headers.splice(3, 0, {
          label: "Source <br> Qty",
          // field: "qty",
          hasSortBy: false,
        });
      }

      return headers;
    },
  },
  methods: {
    searchItems() {
      this.keyword = this.keyword.trim();
      this.getList(this.page);
    },
    initializeDataTable() {
      if (this.dataTable) {
        this.dataTable.destroy();
        this.dataTable = null;
      }

      this.dataTable = $(this.$refs.dataTable).DataTable({
        paging: false,
        searching: false,
        ordering: false,
        info: false,
      });
    },

    searchColumn(index) {
      this.dataTable.column(index).search(this.columnSearch[index]).draw();
    },

    getList(page) {
      this.isLoadDone = false;
      this.isLoadDoneDataTable = false;
      this.items = [];
      this.pagination = {};

      this.showLoader();
      var dataForm = {
        page: page,
        items_to_transfer: 1,
        source_name: this.form.source_name,
        branch: this.form.branch,
      };
      if (this.keyword) {
        dataForm.keyword = this.keyword;
      }

      InventoryService.getItems(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data.data;
            this.pagination = data;
            this.page = this.pagination.current_page;

            data.items.forEach((item) => {
              const clonedItem = { ...item };
              
              if (this.idsSelect.includes(item.id)) {
                const selectedItem = this.itemsSelect.find(itemSelect => itemSelect.id === item.id);
                if (selectedItem) {
                  clonedItem.source_qty = item.source_qty + selectedItem.qty;
                  clonedItem.dest_qty = item.dest_qty;
                  Object.assign(clonedItem, selectedItem);
                }
              }
              
              this.items.push(clonedItem);
            });

            this.isLoadDone = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    changeQty(event, index, item) {
      const itemId = item.id;
      const sourceQty = item.source_qty;
      const destQty = item.dest_qty;
      const indexOf = this.idsSelect.indexOf(itemId);

      if (indexOf == -1) {
        this.idsSelect.push(itemId);
        this.itemsSelect.push({ ...item }); // Clone to avoid reference
      }

      let qty = event.target.value;

      if (this.stockAction == STOCK_TRANSFER) {
        if (qty > sourceQty) {
          qty = sourceQty;
        }
      } else if (this.stockAction == STOCK_OUT) {
        if (qty > destQty) {
          qty = destQty;
        }
      }

      this.items[index].qty = Math.floor(qty);

      this.itemsSelect.forEach((item, indexSelect) => {
        if (item.id == itemId) {
          this.itemsSelect[indexSelect].qty = this.items[index].qty;
        }
      });
    },

    checkItem(itemId, item) {
      const index = this.idsSelect.indexOf(itemId);
      if (index > -1) {
        // Remove if exists
        this.idsSelect.splice(index, 1);
        this.itemsSelect.splice(index, 1);
      } else {
        // Add if not exists
        this.idsSelect.push(itemId);
        this.itemsSelect.push({ ...item }); // Clone to avoid reference
      }
    },

    addItem() {
      this.$emit(
        "add-item",
        [...this.idsSelect],
        JSON.parse(JSON.stringify(this.itemsSelect))
      ); // Pass cloned data
      $(".btn-close-select-item-modal").click();
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
        this.message = "";
      }, 3000);
    },
  },
  watch: {
    keyReload: {
      handler() {
        this.isLoadDone = false;
        this.isLoadDoneDataTable = false;
        this.items = [];
        this.pagination = {};
        this.idsSelect = [...this.idsSelected]; // Reset with cloned data
        this.itemsSelect = JSON.parse(JSON.stringify(this.itemsSelected)); // Reset with cloned data
        this.getList();
      },
    },
    isLoadDone(val) {
      if (val) {
        setTimeout(() => {
          this.initializeDataTable();
          this.isLoadDoneDataTable = true;
        }, 100);
      }
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 99999;
}

.modal-dialog {
  max-width: 70vw;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border: none;
  border-bottom: 1px solid #d2d2d2;
  outline: none;
  width: 100%;
  padding: 4px 4px 4px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
  width: 50%;
}

.search-container .nosubmit {
  flex: 1;
  margin-right: 0;
}

.search-container .search-btn {
  white-space: nowrap;
  flex-shrink: 0;
  margin-bottom: 0 !important;
}

@media screen and (max-width: 768px) {
  .search-container {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .modal-dialog {
    max-width: 95vw;
  }
}
</style>
